export default "__VITE_ASSET__DJ3Jutxp__"